import { render, staticRenderFns } from "./RegisterAccount.vue?vue&type=template&id=a13701aa&"
import script from "./RegisterAccount.vue?vue&type=script&lang=js&"
export * from "./RegisterAccount.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports